import Parse from "parse";

export interface LanguageAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  label: string;
}

export class Language extends Parse.Object<LanguageAttributes> {
  constructor(data?: Partial<LanguageAttributes>) {
    super("APP_Language", data as LanguageAttributes);
  }
}

Parse.Object.registerSubclass("APP_Language", Language);
